// extracted by mini-css-extract-plugin
module.exports = {"mentionListContainer":"nthhkyTFd_Iqnz2PlWyU-"};